var _rect, _rect2, _ellipse, _rect3, _ellipse2, _path, _path2, _path3, _path4, _rect4, _rect5, _ellipse3, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1677,
    height: 896,
    viewBox: "0 0 1677 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1677,
    height: 896,
    fill: "#FFF5B2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 597,
    y: 330,
    width: 485,
    height: 174,
    fill: "#253740"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 839.5,
    cy: 504,
    rx: 242.5,
    ry: 78,
    fill: "#253740"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 597,
    y: 347,
    width: 459,
    height: 157,
    fill: "#2D424D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 826.5,
    cy: 504,
    rx: 229.5,
    ry: 78,
    fill: "#2D424D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M837.83 256.939C840.599 256.585 843.402 256.583 846.171 256.934L1220.83 304.399C1221.53 307.435 1222.64 310.309 1224.11 312.961L779.166 405.212C773.807 406.323 768.255 406.084 763.011 404.516L456 312.69V305.855L837.83 256.939Z",
    fill: "#1E2C33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1211.5 301.5H1222L1224 313L1214 310L1211.5 301.5Z",
    fill: "#1E2C33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M485.5 302L456 300.5V312.5L463 310.5L485.5 302Z",
    fill: "#1E2C33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M837.331 245.034C840.1 244.68 842.903 244.678 845.672 245.028L1220.09 292.464C1220.32 295.578 1220.98 298.573 1222.02 301.387L778.667 393.307C773.308 394.418 767.756 394.179 762.512 392.61L455.838 300.886C454.741 298.571 453.382 296.405 451.801 294.424L837.331 245.034Z",
    fill: "#2D424D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 793.893,
    y: 324.04,
    width: 25.6694,
    height: 179.127,
    rx: 12.8347,
    transform: "rotate(-71.523 793.893 324.04)",
    fill: "#FFD464"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 938,
    y: 352,
    width: 31,
    height: 228,
    rx: 12.8347,
    fill: "#FFD464"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 954,
    cy: 578.5,
    rx: 31,
    ry: 25.5,
    fill: "#E16B5A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 969,
    y: 607,
    width: 16,
    height: 70,
    fill: "#FFD464"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 954,
    y: 607,
    width: 7,
    height: 70,
    fill: "#FFD464"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 938,
    y: 607,
    width: 7,
    height: 70,
    fill: "#FFD464"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 923,
    y: 607,
    width: 7,
    height: 70,
    fill: "#FFD464"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 607,
    width: 8,
    height: 70,
    fill: "#FFE399"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 945,
    y: 607,
    width: 9,
    height: 70,
    fill: "#FFE399"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 961,
    y: 607,
    width: 9,
    height: 70,
    fill: "#FFE399"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 923,
    y: 579,
    width: 62,
    height: 28,
    fill: "#E16B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.1d9cf14ee24d48877ff4006d0ffcc33e.svg";
export { ForwardRef as ReactComponent };